<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header">
        <i class="fa fa-file gray"></i>
        Uploaded  Documents

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body" >
        <div >
          <div class="row">
            <div class="col-md-6">

              <div class="row">

                <div class="card-content col-12">
                  <div class="panel-heading">
                    <div class="row">
                      <div class="col-12">

                        <div class="table-component">
                          <!--<div class="table-responsive">-->
                          <table class="table table-striped table-sm">
                            <thead class="table-bk-primary">
                              <tr>
                                <th scope="col">Documents</th>
                                <th></th>
                                <th></th>




                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let l of CurrentActorDocController">
                                <td>
                                  <div>
                                    {{l.DocFriendlyName}}
                                  </div>
                                  <div>{{l.DocCaptureDate| date:'dd-MMM-yyyy'}}</div>
                                </td>





                                <td>
                                  <div *ngIf="CanDownLoadActorDoc === 1">
                                    <a (click)="DownloadActorDoc(l.ActorDocPageCode)"><i class="fa fa-download">DownLoad</i></a><br />
                                    <a (click)="del_(l.ActorDocPageCode)" *ngIf="CanEdit === 1 "><i class="far fa-trash-alt"></i></a>

                                  </div>
                                </td>
                              </tr>

                            </tbody>
                          </table>
                          <!--</div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 " >
              <div class="card card-search-area form-card">
                <div class="card-header ">Add New Documents</div>
                <div class="card-body">


                  <form novalidate="" (ngSubmit)="onSubmit()" #f="ngForm" >

                    <div class="form-group">
                      <div class="row">
                        <div class="form-group col-12 mb-2">
                          <label for="eventInput2">Friendly Name for Document<span>*</span></label>
                          <input type="text" class="form-control docup1" id="DocFriendlyName" [(ngModel)]="DocFriendlyName"
                                 name="DocFriendlyName" placeholder="Friendly Name for Document" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                 required maxlength="30" minlength="1" #DocFriendlyName1="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!DocFriendlyName1.valid && (DocFriendlyName1.dirty || DocFriendlyName1.touched) && DocFriendlyName1.errors.required)">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!DocFriendlyName1.valid && DocFriendlyName1.errors.pattern)">(special characters are not allowed)</small>
                        </div>
                      </div>
                      <div class="col-12 form-file">
                        <input type="file" class="form-control docup2" (change)="fileChange($event)"
                               name="UploadActorDoc" id="UploadActorDoc"
                               [(ngModel)]="UploadActorDoc" placeholder="Upload">
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="margin-left-auto2">
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-primary modal-button-center">Upload</button>


                      </div>
                    </div>


                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="modal-body" *ngIf="CanNurseView === 0 ">
        <div *ngIf="CanShow === 1 ">
          <div class="row">
            <div class="col-md-12">

              <div class="row">

                <div class="card-content col-12">
                  <div class="panel-heading">
                    <div class="row">
                      <div class="col-12">

                        <div class="table-component">
                          <!--<div class="table-responsive">-->
                          <table class="table table-striped table-sm">
                            <thead class="table-bk-primary">
                              <tr>
                                <th scope="col">Documents</th>
                                <th> Date</th>
                                <th> </th>




                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let l of CurrentActorDocController">
                                <td>
                                  <div>
                                    {{l.DocFriendlyName}}
                                  </div>
                                
                                </td>
                                <td>
                                  <div>{{l.DocCaptureDate| date:'dd-MMM-yyyy'}}</div>
                                </td>




                                <td>
                                  <div *ngIf="CanDownLoadActorDoc === 1">
                                    <a (click)="DownloadActorDoc(l.ActorDocPageCode)"><i class="fa fa-download nav-link-hand" title="Download">DownLoad</i></a><br />
                                    <a (click)="del_(l.ActorDocPageCode)" *ngIf="CanEdit === 1 "><i class="far fa-trash-alt"></i></a>

                                  </div>
                                </td>
                              </tr>

                            </tbody>
                          </table>
                          <!--</div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <!--<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>-->
    </div>
  </div>
  </div>
